export { default } from './HoldsPrintList';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPrintList/index.js